







































































import {
  computed,
  defineComponent, ref,
} from '@vue/composition-api';
import { RightArrowOutline12, CloseOutline16 } from '@hb/coffee-icons';
import { getDetailUrl } from '@/views_v2/apply-product/components/rights/zhenxiang-card/utils/getDetailUrl';
import type { ApplyChannelData } from '@/api/apply-product/types';
import { RightPackageSourceEnum } from '@/api/rights/types';
import { styleNumPxToVm } from '@/shared/utils/style-unit';
import { hideRightsDetail, showRightsDetail } from '../utils/rightsDetailHelper';
import { rightsManager } from '../RightsManager';
import type { RightsContext } from '../types';

export default defineComponent({
  name: 'NormalTab',
  components: {
    RightArrowOutline12,
  },
  setup(props) {
    const rightSummaryData = computed(() => rightsManager.context.value.rightSummaryData);
    const isDiscountUser = computed(() => rightSummaryData.value?.originalPrice
    && rightSummaryData.value?.sellPrice !== rightSummaryData.value?.originalPrice);

    // 控制关闭按钮显示状态
    const showClose = ref(true);

    const handleDetailClick = () => {
      if (rightSummaryData.value) {
        const showUnopenedDetailUrl = !!rightSummaryData.value?.unopenedDetailUrl;
        const context = rightsManager.context.value as RightsContext;
        const rightsUrl = getDetailUrl(
          {
            channelInfo: context.channel as ApplyChannelData,
            rightParams: rightSummaryData.value,
            from: RightPackageSourceEnum.FINANCE_HOME_CREDIT_LOAN_APPLY_PAGE_DETAIL,
          },
        );

        if (!rightsUrl) {
          return;
        }

        showRightsDetail(
          rightsUrl,
          {
            popupTitle: showUnopenedDetailUrl ? '臻享权益' : '',
            fullScreen: false,
            showUnopenedDetailUrl: !!showUnopenedDetailUrl,
            showClose: showClose.value,
            onChangeClose: (closeStatus: boolean) => {
              showClose.value = closeStatus;
            },
            // 使用 render h 函数创建自定义 header
            headerSlot: (h) => h('div', {
              style: {
                position: 'relative',
                width: '100%',
                backgroundColor: 'transparent',
                zIndex: 1001,
              },
            }, showClose.value ? [
              h(CloseOutline16, {
                style: {
                  position: 'absolute',
                  top: `${styleNumPxToVm(14)}vw`,
                  right: `${styleNumPxToVm(14)}vw`,
                  fontSize: `${styleNumPxToVm(16)}vw`,
                },
                on: {
                  click: hideRightsDetail,
                },
              }),
            ] : []),
          },
        );
      }
    };

    return {
      rightSummaryData,
      isDiscountUser,
      handleDetailClick,
    };
  },
});
